<template>
  <vs-table hover-flat v-if="records" :data="records">
    <template slot="thead">
      <vs-th v-text="$t('extension_status_data_analysis_extension_number')"></vs-th>
      <vs-th class="text-center" v-text="$t('talk_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('rest_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('lunch_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('after_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('ready_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('total_time_min')"></vs-th>
      <vs-th class="text-center" v-text="$t('view_details')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data-tr-title="$t('extension_status_data_analysis_extension_number')">
          <span v-if="tr.extension_number" v-text="tr.extension_number"></span>
          <span v-if="tr.agent_name" v-text="` - ${tr.agent_name}`"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('talk_time_min')">
          <span v-if="tr.talktime" v-text="tr.talktime.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('rest_time_min')">
          <span v-if="tr.break" v-text="tr.break.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('lunch_time_min')">
          <span v-if="tr.lunch" v-text="tr.lunch.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('after_time_min')">
          <span v-if="tr.postProcessing" v-text="tr.postProcessing.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('ready_time_min')">
          <span v-if="tr.auth" v-text="tr.auth.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('total_time_min')">
          <span v-if="tr.total" v-text="tr.total.displayValue"></span>
          <span v-else v-text="0"></span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-eye"
              size="small"
              class="saveButton"
              @click="$emit('extensionViewDetails', indextr, tr)"
            ></vs-button>&nbsp;
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.ExtensionStatusDataAnalysis.List',
  props: {
    records: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
